var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");

var DropDownNotification = require("components/notifications/DropDownNotification");
var Modal = require("components/utility/AltModal");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var CalendlyContainer = require("components/notifications/CalendlyContainer");

require("notifications/drop_down_notifications.scss");

class NotificationContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			dropDownNotifications: {}, siteMessageInfo: {}, allowFormatting: false, calendlyModalInfo: {}
		};
	}

	// notificationProps: 	See propTypes for DropDownNotification.js ('shown' set manually)
	// duration: 			Time the notification should show (in ms, default 2000)
	newDropDownNotification(notificationProps, duration) {
		duration = duration || 3000;

		var key = this.generateKey();

		var updatedList = _.clone(this.state.dropDownNotifications);
		updatedList[key] = notificationProps;

		this.setState({ dropDownNotifications: updatedList });

		// Set timeout for finally removing the item from our state
		setTimeout(function() {
			this.buildRemoveFunction("dropDownNotifications", key)();
		}.bind(this), duration);
	}

	newModalNotification(userAlertInfo, allowFormatting) {
		this.setState({ siteMessageInfo: userAlertInfo, allowFormatting: allowFormatting })
		this.refs.modal.show();
	}

	newCalendlyModal(userAlertInfo) {
		this.setState({ calendlyModalInfo: userAlertInfo })
		this.refs.modal.show();
	}

	generateKey() {
		return Math.random().toString(36).slice(2);
	}

	buildRemoveFunction(notificationType, key) {
		return function() {
			var updatedList = _.clone(this.state[notificationType]);
			if (updatedList[key]) {
				delete updatedList[key];

				var stateUpdate = {}; stateUpdate[notificationType] = updatedList;
				this.setState(stateUpdate);				
			}
		}.bind(this);
	}

	render() {
		var dropDowns = _.map(this.state.dropDownNotifications, function(props, key) {
			var useProps = _.omit(props, "duration");
			return (
				<CSSTransition classNames="drop-down" timeout={{ enter: 500, exit: 500 }} key={ key }>
					<DropDownNotification { ...useProps }
						onClick={ this.buildRemoveFunction("dropDownNotifications", key) } />
				</CSSTransition>
			)
		}.bind(this));

		var siteMessageLinks = ''
		if (this.state.calendlyModalInfo.data && this.state.calendlyModalInfo.data.calendly_url) {
			var siteMessageParagraphs = <CalendlyContainer url={ this.state.calendlyModalInfo.data.calendly_url } />
		} else if (this.state.siteMessageInfo.text) {
			var className = "twoThirdsWidth";
			if (this.state.allowFormatting) {
				var siteMessageParagraphs = FeedbackFormatter.format(this.state.siteMessageInfo.text);
				if (this.state.siteMessageInfo.data) {
					var data = this.state.siteMessageInfo.data
					if (data.cta_url && data.cta_text) {
						siteMessageLinks = (
							<div className="siteMessageLinks">
								<a  className='btn btn-primary' href={ data.cta_url } >{ data.cta_text }</a>
							</div>
						)
					}
				}
			} else {
				var siteMessageTexts = this.state.siteMessageInfo.text.split("\n");
				var siteMessageParagraphs = siteMessageTexts.map((text, index) => {
					return ( 
						<p key={ index }>{ text }</p>
					)
				})
			}
			if (this.state.siteMessageInfo.data.survey_url) {
				var url = "https://docs.google.com/forms/d/1zNYW0GNrS2XAjhSxRWIwMml0LHZKJsuEmJspkZ1lwo0/"
				var studentSurveyContainer = (
					<div className="studentSurveyContainer">
						<img src={ require("owls/owlfonso-waving-hat.png") } />
						<a className="buttonPrimary" href={ url } target="_blank">Take Survey!</a>
					</div>
				)
			}
		}
		var title = this.state.siteMessageInfo.title || this.state.calendlyModalInfo.title
		return (
			<div>
				<TransitionGroup>
					{ dropDowns }
				</TransitionGroup>
				<Modal className={ className } ref="modal"  headerText={ title }>
					<div className="modalBody">
						{ siteMessageParagraphs }
						{ studentSurveyContainer }
						{ siteMessageLinks }
					</div>	
				</Modal>
			</div>
		);
	}

	componentDidMount() {
		if (window.wrNotifications == undefined) {
			window.wrNotifications = {};
		}
		window.wrNotifications.triggerDropDownNotification = this.newDropDownNotification;
		window.wrNotifications.triggerModalNotification = this.newModalNotification;

		if (window.wrNotifications.pendingModalNotifications) {
			_.each(window.wrNotifications.pendingModalNotifications, function(alertPair) {
				window.wrNotifications.triggerModalNotification(alertPair[0], alertPair[1])
			});
		}

		window.wrNotifications.triggerCalendlyModal = this.newCalendlyModal;

		if (window.wrNotifications.pendingCalendlyModal) {
			_.each(window.wrNotifications.pendingCalendlyModal, function(alert) {
				window.wrNotifications.triggerCalendlyModal(alert)
			});
		}	
	}

	componentWillUnmount() {
		delete window.wrNotifications;
	}
};

NotificationContainer.propTypes = StrictPropTypes({
});

module.exports = NotificationContainer;


// WEBPACK FOOTER //
// ./modules/components/notifications/NotificationContainer.js